import React from "react";
import { LoginForm } from "../../../components/Admin/Auth";
import { LanguageSwitcher } from "../../../components/Admin/AdminLayout/LanguageSwitcher";
import { logoEduca } from "../../../assets";
import "../Auth/Auth.scss";

export function AuthTeacherstudents() {
  return (
    <div className="auth">
      <img src={logoEduca.logoE360} alt="Educa360" className="logo" />
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          width: "100%",
          marginBottom: 8,
        }}
      >
        <LanguageSwitcher />
      </div>
      <LoginForm />
    </div>
  );
}
